import { render, staticRenderFns } from "./CheckBundle.vue?vue&type=template&id=6b138547&scoped=true&"
import script from "./CheckBundle.vue?vue&type=script&lang=js&"
export * from "./CheckBundle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b138547",
  null
  
)

export default component.exports